import React, { Component } from 'react';
import logo from 'assets/images/logo.svg';
import { FormattedMessage, injectIntl } from 'react-intl';
import { PATH, STORAGE_KEY } from 'shared/constants';
import { Button } from 'components';
import { connect } from 'react-redux';
import { switchLanguage } from 'shared/redux/actions';
// import baseUrl from 'shared/util/baseUrl';
import './Language.scss';
import trackEvent from 'components/TrackEvent/TrackEvent';
import { eventSelectLanguage } from 'components/TrackEvent/constEvent';

class Language extends Component {
  componentDidMount() {
    const { history } = this.props;

    // redirect to homepage after first time visit
    if (localStorage.getItem(STORAGE_KEY.FIRST_TIME_VISIT) && history.action === 'POP' && history.location.pathname !== PATH.LANGUAGE) {
      history.push(PATH.HOME);
    } else {
      localStorage.setItem(STORAGE_KEY.FIRST_TIME_VISIT, 'true');
    }
  }

  handleButtonClick = () => {
    const { history, intl, currentLocale } = this.props;
    trackEvent(eventSelectLanguage(currentLocale, intl.formatMessage({ id: 'language.ok' })));

    if (history.action === 'POP') {
      history.push(PATH.HOME); // history.push(PATH.WELCOME); - previously link to welcome
    } else {
      history.goBack();
    }
  }

  render() {
    const { onSwitchLanguage, currentLocale } = this.props;
    const languages = [
      {
        id: 'EN',
        title: 'English',
        text: 'Welcome',
      },
      {
        id: 'AR',
        title: 'عربي',
        text: 'أهلا بك',
      },
    ];

    return (
      <section className="app-wrapper__body nw-page-language">
        <img src={logo} alt="Logo" />
        {/* <img src={`${baseUrl}/markaz-192.png`} alt="Logo" /> */}
        <h1><FormattedMessage id="language.title" /></h1>
        <div className="nw-page-language__switcher">
          {
                languages && languages.map(item => (
                  <button
                    key={item.id}
                    type="button"
                    className={`nw-page-language__button ${currentLocale === item.id ? 'nw-page-language__button--active' : ''}`}
                    onClick={() => onSwitchLanguage(item.id)}
                  >
                    <span className="nw-page-language__button-checkbox" />
                    <h5>{item.title}</h5>
                    <p>{item.text}</p>
                  </button>
                ))
            }
        </div>
        <Button
          value={(<FormattedMessage id="language.ok" />)}
          isOutlineButton
          isBig
          onButtonClick={this.handleButtonClick}
        />
      </section>
    );
  }
}

const mapStateToProps = state => ({
  currentLocale: state.rootReducer.language.locale,
});

const mapDispatchToProps = dispatch => ({
  onSwitchLanguage: id => dispatch(switchLanguage(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(Language));
